"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
/**
 * Gets an Apollo client fragment matcher for Apollo client and test utils.
 */
const getFragmentMatcherGenerator = types => () => new apollo_cache_inmemory_1.IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types
    }
  }
});
exports.default = getFragmentMatcherGenerator;